import { CompletedCollectible, DraftCollectible } from "@/types/collectibles"
import { Blog, Note } from "@types"

export type NFTMintBtnProps =
  | {
      collectible: CompletedCollectible
      blog: Blog
    }
  | {
      collectible: DraftCollectible
      blog: Blog
      post: Note
    }

export type CompletedNFTMintBtnProps = {
  collectible: CompletedCollectible
  className?: string
}

export const isCompletedCollectible = (
  collectible: CompletedCollectible | DraftCollectible
): collectible is CompletedCollectible => {
  return "txHash" in collectible
}
export const isDraftCollectible = (
  props: NFTMintBtnProps
): props is { collectible: DraftCollectible; blog: Blog; post: Note } => {
  return !isCompletedCollectible(props.collectible)
}
